const BaseURL = process.env.REACT_APP_BASE_URL;
// const BaseURL = "http://192.168.98.29:5619";

const Endpoint = {
  auth: {
    login: "/user/auth/sign-in",
    forgotPassword: "/user/auth/forgot-password",
    resetPassword: "/user/auth/reset-password",
    refreshToken: "/user/auth/refresh-token",
  },
  user: {
    changePassword: "/user/auth/change-password",
    addCollaborator: "/user/add-collaborators",
    searchBuilder: "/user/search-builder",
    searchCollaborator: "/user/search-collaborator",
    deleteCollaborator: "/user/delete-collaborator/:collaborator_id",
    getProfile: "/user/profile",
    updateUser: "/user/profile",
    userFeedback: "/user/feedback/create",
    userDashboardWaitingRevisions: "/user/dashboard/waiting-revisions",
  },
  project: {
    list: "/user/project/list",
    clientOnboardingProject: "/user/project/client-onboarding-project",
    projectDetail: "/user/project/:project_id",
    projectExtendedDetail: "/user/project/:project_id/detail",
    projectOnboarding: "/user/project/onboarding/:project_id",
    projectNextStatus: "/user/project/:project_id/next-status",
    projectComplete: "/user/project/:project_id/complete",
    dismissReadyToStart: "/user/project/:project_id/dismiss-ready-to-start",
    projectSelection: "/user/project/selection",
    projectDocumentDownload: "/user/project/download/:project_id",
    addProjectDesigner: "user/project/:project_id/designer",
    leaveProjetcDesigner: "user/project/:project_id/designer",
    projectArchive: "user/project/:project_id/archive",
    projectCollaborators: "/user/project/:project_id/collaborators",
  },
  revision: {
    getProjectRevision: "/user/revision/project/:project_id",
    designerUploadRevision: "/user/revision/designer-upload",
    revisionUploadFile: "/user/revision/upload-file",
    revisionClientResponse: "/user/revision/client-response/:revision_id",
    deleteDesignerUpload: "/user/revision/designer-upload/:designer_upload_id",
    updateDesignerUploads: "/user/revision/:revision_id/designer-uploads",
    setRevisionMediaSort: "/user/revision/:revision_id/media-sort",
    revisionProjectHistory: "/user/revision/project/:project_id/history",
    downloadRevisionFiles:
      "/user/revision/download-revision-files/:revision_id",
    getRevisionUploads: "/user/revision/:revision_id/uploads",
    downloadDesignerUpload:
      "/user/revision/download-designer-upload/:designer_upload_id",
    downloadRevisionInspiration:
      "/user/revision/download-inspiration/:revision_inspiration_id",
    getProjectRevisionList: "/user/revision/selection/:project_id",
    getRevisionFeedback: "/user/revision/feedback/:revision_id",
    setRevisionInProgress: "/user/revision/:revision_id/in-progress",
    markRevisionViewed: "/user/revision/:revision_id/mark-viewed",
    updateRevisionInspirations: "/user/revision/:revision_id/inspirations",
    getLatestFeedback: "/user/revision/latest-feedback/:project_id",
  },
  comment: {
    getAllComments: "/user/comment/board/:board_id",
    createComment: "/user/comment/:board_id",
    // updateComment: "/user/comment/:comment_id",
    // deleteComment: "/user/comment/:comment_id",
  },
  reply: {
    getAllReplies: "/user/reply/comment/:comment_id",
    createReply: "/user/reply/:comment_id",
    // updateReply: "/user/reply/:reply_id",
    // deleteReply: "/user/reply/:reply_id",
  },
  notifications: {
    getNotifications: "/user/notification/list",
    readNotification: "/user/notification/:notification_id/read",
    getCount: "/user/notification/count",
    markAllRead: "/user/notification/mark-all-read",
    projectsWithUnreadChat: "/user/notification/project/chat-unread",
    projectChatUnread: "/user/notification/project/:project_id/chat-unread",
    projectChatRead: "/user/notification/project/:project_id/chat-read",
  },
};

export { Endpoint, BaseURL };
